import { render, staticRenderFns } from "./talk-to-agent.vue?vue&type=template&id=19d840ee&scoped=true"
import script from "./talk-to-agent.vue?vue&type=script&lang=js"
export * from "./talk-to-agent.vue?vue&type=script&lang=js"
import style0 from "./talk-to-agent.vue?vue&type=style&index=0&id=19d840ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d840ee",
  null
  
)

export default component.exports